import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';

import type {StatusCommandResponse} from '../../../dto/extension/StatusCommandResponse';

export class StatusCommand extends Command<GetMethod, StatusCommandResponse> {
  constructor(id: string) {
    super(get, {
      path: `/extension/command-status/${id}`,
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<StatusCommandResponse> {
    const {body, statusCode} = await output.response;
    if (statusCode === 404) {
      return undefined;
    }
    return await (body.json() as unknown as Promise<StatusCommandResponse>);
  }
}
